import { createRouter, createWebHistory } from 'vue-router';
import routes from '@kate-routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'router-link-active active',
  linkExactActiveClass: 'router-link-exact-active active a-exact-active',
});

export default router;
